$(document).ready(function (){
    $('body').on('click', '.home_neighborhoods__see_all-link', function (e){
        e.preventDefault();
        $(this).hide();

        $('.home_neighborhood_item').show(0, function (){
            if ($(this).is(':visible')) {
                $(this).css('display', 'flex');

            }
        });
        $('.home_neighborhood_item:nth-child(4) a').focus();
    });
});